export default __webpack_public_path__ + "static/134-a401fa86d36ae46cd42206836ad7c8a3.jpg";